export let routes = [
  {
    path: '/x3-side-evaluation',
    name: 'x3-side-evaluation',
    component: () => import('@x3/js/side/evaluation/evaluation.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsEvaluation(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-evaluation',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};